// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as IssueForm from "../form-sections/IssueForm.bs.js";
import * as ActionForm from "../form-sections/ActionForm.bs.js";
import * as OrderStage from "../../../../ticket-dashboard/app/tickets/entities/OrderStage.bs.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as TicketRaisedBy from "../../../../ticket-dashboard/app/tickets/entities/TicketRaisedBy.bs.js";
import * as MobileNumberValidation from "../../../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as RaiseTicketDataMachine from "../../../app/repo/RaiseTicketDataMachine.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as RaiseTicketAgentDeskCmp from "./RaiseTicketAgentDeskCmp.bs.js";
import * as RaiseTicketStateMachine from "../RaiseTicketStateMachine.bs.js";
import * as RaiseTicketAgentDeskRequest from "../../../app/entity/RaiseTicketAgentDeskRequest.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function verifyBasicTicketFormInfo(params, country, dispatch) {
  var crn = FormValidationUtils$Catalyst.validateCRN(params.crn);
  var tmp;
  tmp = crn.TAG === /* Ok */0 ? crn._0 : undefined;
  var caller_number = MobileNumberValidation.execute(params.caller_number, country);
  var tmp$1;
  tmp$1 = caller_number.TAG === /* Ok */0 ? caller_number._0 : undefined;
  var basic_ticket_info_data_msisdn = params.msisdn;
  var basic_ticket_info_data_location = params.location;
  var basic_ticket_info_data_order_stage = OrderStage.fromString(params.order_stage);
  var basic_ticket_info_data_raised_by = TicketRaisedBy.fromString(params.raised_by);
  var basic_ticket_info_data = {
    msisdn: basic_ticket_info_data_msisdn,
    crn: tmp,
    location: basic_ticket_info_data_location,
    caller_number: tmp$1,
    order_stage: basic_ticket_info_data_order_stage,
    raised_by: basic_ticket_info_data_raised_by,
    crt_id: undefined
  };
  Curry._1(dispatch, {
        TAG: /* SetTicketInfo */0,
        ticket_info: {
          TAG: /* Live */1,
          _0: basic_ticket_info_data
        }
      });
  Curry._1(dispatch, {
        TAG: /* UpdateBasicInfoFormData */4,
        selected_basic_info: basic_ticket_info_data
      });
  var match = basic_ticket_info_data_msisdn;
  var match$1 = tmp;
  var match$2 = basic_ticket_info_data_location;
  var match$3 = tmp$1;
  var match$4 = basic_ticket_info_data_order_stage;
  var match$5 = basic_ticket_info_data_raised_by;
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined && match$3 !== undefined && match$4 !== undefined) {
    return match$5 !== undefined;
  } else {
    return false;
  }
}

function issuesAreValid(selected_issues, available_issues) {
  if (List.length(selected_issues) <= 0) {
    return false;
  }
  var selected_and_available_issues = List.filter(function (issue) {
          return List.exists((function (available_issue) {
                        return available_issue.issue_name === issue;
                      }), available_issues.issues);
        })(selected_issues);
  return (List.length(selected_and_available_issues) - List.length(selected_issues) | 0) === 0;
}

function verifyIssueFormInfo(params, availableIssues, dispatch) {
  var isCommentRequired = IssueForm.isCommentRequired(availableIssues, params.issues);
  if (!issuesAreValid(params.issues, availableIssues)) {
    return false;
  }
  if (isCommentRequired) {
    var _comment = params.issue_comment;
    if (_comment === undefined) {
      return false;
    }
    var issue_form_data_selected_issue = params.issues;
    var issue_form_data_issue_comment = params.issue_comment;
    var issue_form_data = {
      selected_issue: issue_form_data_selected_issue,
      issue_comment: issue_form_data_issue_comment
    };
    Curry._1(dispatch, {
          TAG: /* UpdateIssueFormData */5,
          issue_form_data: issue_form_data
        });
    return true;
  }
  var _comment$1 = params.issue_comment;
  if (_comment$1 !== undefined) {
    return false;
  }
  var issue_form_data_selected_issue$1 = params.issues;
  var issue_form_data$1 = {
    selected_issue: issue_form_data_selected_issue$1,
    issue_comment: undefined
  };
  Curry._1(dispatch, {
        TAG: /* UpdateIssueFormData */5,
        issue_form_data: issue_form_data$1
      });
  return true;
}

function actionsAreValid(selected_actions, available_actions) {
  if (List.length(selected_actions) <= 0) {
    return false;
  }
  var selected_and_available_actions = List.filter(function (action) {
          return List.exists((function (available_action) {
                        return available_action.action_name === action;
                      }), available_actions.actions);
        })(selected_actions);
  return (List.length(selected_and_available_actions) - List.length(selected_actions) | 0) === 0;
}

function verifyActionFormInfo(params, availableActions, dispatch) {
  var isCommentRequired = ActionForm.isCommentRequired(availableActions, params.actions);
  if (!actionsAreValid(params.actions, availableActions)) {
    return false;
  }
  if (isCommentRequired) {
    var _comment = params.action_comment;
    if (_comment === undefined) {
      return false;
    }
    var action_form_data_selected_actions = params.actions;
    var action_form_data_action_comment = params.action_comment;
    var action_form_data = {
      selected_actions: action_form_data_selected_actions,
      action_comment: action_form_data_action_comment
    };
    Curry._1(dispatch, {
          TAG: /* UpdateActionFormData */6,
          action_form_data: action_form_data
        });
    return true;
  }
  var _comment$1 = params.action_comment;
  if (_comment$1 !== undefined) {
    return false;
  }
  var action_form_data_selected_actions$1 = params.actions;
  var action_form_data$1 = {
    selected_actions: action_form_data_selected_actions$1,
    action_comment: undefined
  };
  Curry._1(dispatch, {
        TAG: /* UpdateActionFormData */6,
        action_form_data: action_form_data$1
      });
  return true;
}

function RaiseTicketAgentDeskRootCmp(Props) {
  var params_from_agent_desk = Props.params_from_agent_desk;
  var match = React.useReducer(RaiseTicketStateMachine.reducer, RaiseTicketStateMachine.intitial_state);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setValidationState = match$1[1];
  var is_validation_completed = match$1[0];
  var params = RaiseTicketAgentDeskRequest.fromDict(params_from_agent_desk);
  var match$2 = CountryContext.useContext(undefined);
  var country = match$2.country;
  React.useEffect((function () {
          RaiseTicketDataMachine.fetchTicketIssues(OrderStage.nonOptionalfromString(params.order_stage), country, (function (issues) {
                  return Curry._1(dispatch, {
                              TAG: /* SetAvailableIssues */1,
                              issues: {
                                TAG: /* Live */1,
                                _0: issues
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetTicketInfo */0,
                              ticket_info: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
          RaiseTicketDataMachine.fetchTicketActions(OrderStage.nonOptionalfromString(params.order_stage), country, (function (actions) {
                  return Curry._1(dispatch, {
                              TAG: /* SetAvailableActions */2,
                              actions: {
                                TAG: /* Live */1,
                                _0: actions
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetAvailableActions */2,
                              actions: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
          
        }), []);
  React.useEffect((function () {
          if (!is_validation_completed) {
            var match = state.issues;
            var match$1 = state.actions;
            if (typeof match !== "number" && match.TAG === /* Live */1 && typeof match$1 !== "number" && match$1.TAG === /* Live */1) {
              var basicInfoValid = verifyBasicTicketFormInfo(params, country, dispatch);
              var issueInfoValid = verifyIssueFormInfo(params, match._0, dispatch);
              var actionInfoValid = verifyActionFormInfo(params, match$1._0, dispatch);
              var exit = 0;
              if (basicInfoValid && issueInfoValid) {
                if (actionInfoValid) {
                  EventTracker.publishEvent({
                        category: "Raise Ticket (using AgentDesk)",
                        action: "Landed on Actions page",
                        label: "Random",
                        value: undefined,
                        nonInteraction: undefined
                      });
                  Curry._1(dispatch, {
                        TAG: /* UpdateView */3,
                        current_view: /* ActionForm */2
                      });
                  Curry._1(setValidationState, (function (param) {
                          return true;
                        }));
                } else {
                  EventTracker.publishEvent({
                        category: "Raise Ticket (using AgentDesk)",
                        action: "Landed on Issues page",
                        label: "Random",
                        value: undefined,
                        nonInteraction: undefined
                      });
                  Curry._1(dispatch, {
                        TAG: /* UpdateView */3,
                        current_view: /* IssueForm */1
                      });
                  Curry._1(setValidationState, (function (param) {
                          return true;
                        }));
                }
              } else {
                exit = 1;
              }
              if (exit === 1) {
                EventTracker.publishEvent({
                      category: "Raise Ticket (using AgentDesk)",
                      action: "Landed on Basic Info page",
                      label: "Random",
                      value: undefined,
                      nonInteraction: undefined
                    });
                Curry._1(dispatch, {
                      TAG: /* UpdateView */3,
                      current_view: /* BasicInfoForm */0
                    });
                Curry._1(setValidationState, (function (param) {
                        return true;
                      }));
              }
              
            }
            
          }
          
        }), [
        state.issues,
        state.actions
      ]);
  if (is_validation_completed) {
    return React.createElement(RaiseTicketAgentDeskCmp.make, {
                state: state,
                dispatch: dispatch
              });
  } else {
    return React.createElement(CircularLoader$Catalyst.make, {});
  }
}

var make = RaiseTicketAgentDeskRootCmp;

export {
  verifyBasicTicketFormInfo ,
  issuesAreValid ,
  verifyIssueFormInfo ,
  actionsAreValid ,
  verifyActionFormInfo ,
  make ,
  
}
/* react Not a pure module */
